import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BenefitTrans, TableFeature, useTiersInfo } from '@mc/plans-ui'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'

export const DevicesFeature = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { duo, family, individual } = useTiersInfo()

  return (
    <TableFeature.Feature>
      <TableFeature.Label
        title={t('plans.features.devices.title')}
        subtitle={t('plans.features.devices.subtitle')}
      />
      <TableFeature.Individual>
        <BenefitTrans
          tier={individual}
          name='concurrent_devices'
          defaultValue={false}
          i18nKey='plans.features.devices.counter'
          ns={CHECKOUT_I18N_NAMESPACE}
        />
      </TableFeature.Individual>
      <TableFeature.Duo>
        <BenefitTrans
          tier={duo}
          name='concurrent_devices'
          i18nKey='plans.features.devices.counter'
          ns={CHECKOUT_I18N_NAMESPACE}
        />
      </TableFeature.Duo>
      <TableFeature.Family>
        <BenefitTrans
          tier={family}
          name='concurrent_devices'
          i18nKey='plans.features.devices.counter'
          ns={CHECKOUT_I18N_NAMESPACE}
        />
      </TableFeature.Family>
    </TableFeature.Feature>
  )
}
